module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-bold app-navbar animated",
    class: {
      slideInDown: _vm.show, slideOutDown: !_vm.show
    }
  }, [_c('div', {
    staticClass: "hero-head"
  }, [_c('nav', {
    staticClass: "navbar is-transparent"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('a', {
    staticClass: "navbar-item",
    attrs: {
      "href": "/#"
    }
  }, [_c('img', {
    attrs: {
      "src": require("assets/logo-white.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "vue"
  }, [_vm._v(_vm._s(_vm.$t('index.navbar_title')))])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-burger burger animated is-hidden-tablet",
    on: {
      "click": function($event) {
        _vm.toggleSidebar(!_vm.sidebar.opened)
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-end is-hidden-touch"
  }, [_c('div', {
    staticClass: "navbar-item"
  }, [_c('div', {
    staticClass: "field is-grouped"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$i18n.locale),
      expression: "$i18n.locale"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.$i18n, "locale", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "ru"
    }
  }, [_vm._v("Русский")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "en"
    }
  }, [_vm._v("English")])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56718234"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/layout/Navbar.vue
// module id = 311
// module chunks = 2